import i from"styled-components";const o=i.div`
	display: inline-flex;
	padding: 20px;
	align-items: flex-start;
	gap: 10px;

	border-radius: 16px;
	border: 1px solid rgba(127, 3, 104, 0.1);
	background: #fdd9f5;
	box-shadow: 0 4px 10px 0 rgba(165, 207, 225, 0.4);
`,r=i.div`
	color: #7f0368;
	font-family: "SF Pro Display";
	font-size: 18px;
	line-height: 1.4;
	letter-spacing: 0.2px;

	a {
		color: inherit;
	}
`;export{o as NotificationPanelContainer,r as NotificationPanelContent};
